module.exports = "/_next/static/images/bdc26ce775c4e4daa2b7ffbb5fd5de5f-aboutus-xpeer-desktop.jpg";